import React, { useState } from 'react';
import './FAQComponent.css';

function FAQItem({ question, answer, isOpen, onToggle }) {
  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <button className="faq-question" onClick={onToggle} aria-expanded={isOpen}>
        <span>{question}</span>
        <span className="faq-chevron" aria-hidden="true">＋</span>
      </button>
      <div className="faq-answer-wrap">
        <div className="faq-answer">{answer}</div>
      </div>
    </div>
  );
}

function FAQComponent() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: 'How do you measure your max heart rate?',
      answer:
        'Subtract your age from 220. For example, a 50-year-old would have an estimated max heart rate of 170 bpm (220 − 50).',
    },
    {
      question: 'How do you measure moderate-intensity physical activity?',
      answer:
        'Your target heart rate should be between 64% and 76% of your maximum heart rate.',
    },
    {
      question: 'How do you measure vigorous-intensity physical activity?',
      answer:
        'Your target heart rate should be between 77% and 93% of your maximum heart rate.',
    },
  ];

  return (
    <section className="faq-container">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqData.map((faq, i) => (
          <FAQItem
            key={i}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIndex === i}
            onToggle={() => setOpenIndex(openIndex === i ? null : i)}
          />
        ))}
      </div>
    </section>
  );
}

export default FAQComponent;
